import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Maintenance from './Pages/UnderMaintenance';
import Header from './Components/Header/Header';
import CookieBanner from './Components/Banner/Banner';
import Footer from './Components/Footer/Footer';
import Challenges from './Pages/Challenges';
import Desafios from './Pages/Desafios';
import Quemsomos from './Pages/Quemsomos';
import Aboutus from './Pages/Aboutus';
import Contacts from './Pages/Contacts';
import Contactos from './Pages/Contactos';
import Reservas from './Pages/Reservas';
import Bookings from './Pages/Bookings';
import Vouchers from './Pages/VouchersPT';
import Voucher from './Pages/VouchersEN';
import Termos from './Pages/Termos';
import Terms from './Pages/Terms';
import Politicas from './Pages/Politicas';
import Politics from './Pages/Politics';
import Inicio from './Pages/Inicio';
import Homepage from './Pages/Homepage';
import TB from './Pages/TeamBuildings';
import Aniversarios from './Pages/Aniversarios';
import BirthdayParties from './Pages/BirthdayParties';
import DespedidasSolteiro from './Pages/DespedidasSolteiro';
import BacheloretteParty from './Pages/BacheloretteParty';
import TBPT from './Pages/TeamBuildingsPT';
import LCPT from './Pages/LoretoChallengePT';
import LCEN from './Pages/LoretoChallengeEN';
import FestaHistoriaApp from './FestaHistoria/FestaHistoriaApp';

function MainSite({ language, handleMenuClick }) {
  const getRedirectPath = () => {
    const lang = localStorage.getItem('selectedLanguage') || 'pt';
    return lang === 'pt' ? '/inicio' : '/homepage';
  };

  return (
    <div className="er-appFrame">
      <Header onHeaderClick={handleMenuClick}/>
      <main className="er-appMain">
        <Routes>
          <Route path="/" element={<Navigate to={getRedirectPath()} />} />
          {language === 'pt' ? (<Route path='/desafios/' element={<Desafios/>} />) : (<Route path='/challenges' element={<Challenges/>} />)}
          {language === 'pt' ? (<Route path='/reservas/' element={<Reservas/>} />) : (<Route path='/bookings' element={<Bookings/>} />)}
          {language === 'pt' ? (<Route path='/quemsomos/' element={<Quemsomos/>} />) : (<Route path='/aboutus' element={<Aboutus/>} />)}
          {language === 'pt' ? (<Route path='/contactos/' element={<Contactos/>} />) : (<Route path='/contacts' element={<Contacts/>} />)}
          {language === 'pt' ? (<Route path='/vouchers/' element={<Vouchers/>} />) : (<Route path='/voucher' element={<Voucher/>} />)}
          {language === 'pt' ? (<Route path='/termos/' element={<Termos/>} />) : (<Route path='/terms' element={<Terms/>} />)}
          {language === 'pt' ? (<Route path='/politicas/' element={<Politicas/>} />) : (<Route path='/politics' element={<Politics/>} />)}
          {language === 'pt' ? (<Route path='/inicio/' element={<Inicio/>} />) : (<Route path='/homepage' element={<Homepage/>} />)}
          {language === 'pt' ? (<Route path='/aniversarios/' element={<Aniversarios/>} />) : (<Route path='/birthday-parties' element={<BirthdayParties/>} />)}
          {language === 'pt' ? (<Route path='/despedidas-solteiro/' element={<DespedidasSolteiro/>} />) : (<Route path='/bachelorette-party' element={<BacheloretteParty/>} />)}
          {language === 'pt' ? (<Route path='/team-buildings/' element={<TBPT/>} />) : (<Route path='/team-building' element={<TB/>} />)}
          {language === 'pt' ? (<Route path='/loreto-challenge/' element={<LCPT/>} />) : (<Route path='/loretochallenge' element={<LCEN/>} />)}
          <Route path="*" element={<Navigate to={getRedirectPath()} />} />
        </Routes>
      </main>
      <Footer/>
      <CookieBanner/>
    </div>
  );
}

function AppRoutes({ language, handleMenuClick }) {
  const location = useLocation();
  const isFestaHistoria = location.pathname.startsWith('/festa-historia');

  if (isFestaHistoria) {
    return (
      <Routes>
        <Route path="/festa-historia/*" element={<FestaHistoriaApp />} />
      </Routes>
    );
  }

  return <MainSite language={language} handleMenuClick={handleMenuClick} />;
}

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isUnderMaintenance, setIsUnderMaintenance] = useState(false);
  const [language, setLanguage] = useState();

  //eslint-disable-next-line
  const [menuItem, setMenuItem] = useState();

  const handleMenuClick = (page, lang) => {
    if(lang !== language) {
      setMenuItem(page);
      setLanguage(lang);
      localStorage.setItem('selectedLanguage', lang);
      window.location.reload();
    }
    else {
      setMenuItem(page);
      setLanguage(lang);
      localStorage.setItem('selectedLanguage', lang);
    }
  }

  useEffect(() => {
    const fetchMaintenanceStatus = async () => {
      setTimeout(() => {
        setIsUnderMaintenance(false);
        setIsLoading(false);

        const selectedLanguage = localStorage.getItem('selectedLanguage') || 'pt';
        setLanguage(selectedLanguage);
        setMenuItem(2);
      }, 300);
    };

    fetchMaintenanceStatus();
  }, []);

  return (
    <div className="App">
      {isLoading ? (
        <div className='loadingContainer'><h1 className='loadingText'>Loading...</h1></div>
      ) : (
        isUnderMaintenance ? (
          <Maintenance/>
        ) : (
          <Router>
            <AppRoutes language={language} handleMenuClick={handleMenuClick} />
          </Router>
        )
      )}
    </div>
  );
};

export default App;
